<template>
  <div id="event-detail-page" v-if="post">
    <header
      class="post-featured-image"
      :style="{ backgroundImage: `url(${post.mainImageUrl})` }"
    ></header>
    <article>
      <h1 class="post-title">{{ post.title }}</h1>
      <div class="post-content" v-html="post.content"></div>
      <table class="event-detail">
        <tbody>
          <tr v-if="post.address">
            <th>Venue</th>
            <td>{{ post.address || "N/A" }}</td>
          </tr>
          <tr v-if="post.organizer">
            <th>Organizer</th>
            <td>{{ post.organizer || "N/A" }}</td>
          </tr>
        </tbody>
      </table>
    </article>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "EventDetail",
  data() {
    return {
      post: null,
    };
  },
  methods: {
    load(name) {
      const url = process.env.VUE_APP_API_URI;
      const postData = {
        query: `query event($name: String) { event(name: $name) { id title name content address organizer websiteLink mainImageUrl } }`,
        variables: {
          name,
        },
      };
      axios
        .post(url, postData, {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        })
        .then((res) => {
          this.post = res.data.data.event;
        })
        .catch(console.error);
    },
  },
  mounted() {
    const name = this.$route.params.name;
    this.load(name);
  },
};
</script>

<style lang="scss" scoped>
#event-detail-page {
  padding: 52px 0 0;

  .post-featured-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 0;
    padding-bottom: 75%;
  }

  article {
    margin: 0 20px;
  }

  .post-title {
    font-size: 1.5rem;
    margin: 1rem 0;
    text-align: center;
  }

  .post-content {
    text-align: center;
    margin: 1rem 0;
  }
}
</style>
